<template>
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2461_1034)">
            <path
                d="M5.08621 9.31006L5.08622 13.7636C5.08622 14.638 7.06233 16.3277 9.49998 16.3277C11.9376 16.3277 13.9137 14.638 13.9137 13.7636L13.9137 9.31006"
                stroke="#1D1E20" stroke-width="1.2" />
            <path
                d="M1.42782 4.94856C1.10181 4.81498 1.09522 4.35568 1.41726 4.2128L9.34274 0.696541C9.44578 0.650824 9.56334 0.650711 9.66647 0.696229L17.6333 4.21246C17.9562 4.35501 17.9497 4.81555 17.6227 4.94881L9.65587 8.19625C9.55885 8.2358 9.45018 8.2357 9.35323 8.19598L1.42782 4.94856Z"
                stroke="#1D1E20" stroke-width="1.2" />
            <path d="M17.875 7.43755L9.88458 10.7486C9.64074 10.8496 9.36685 10.8501 9.12261 10.7501L1.26343 7.52979"
                stroke="#1D1E20" stroke-width="1.2" stroke-linecap="round" />
            <path d="M16.5746 12.3611V8.18701" stroke="#1D1E20" stroke-width="1.2" />
            <path
                d="M15.9746 14.217C15.9746 14.5484 16.2432 14.817 16.5746 14.817C16.906 14.817 17.1746 14.5484 17.1746 14.217H15.9746ZM17.1746 14.217V13.488H15.9746V14.217H17.1746Z"
                fill="#1D1E20" />
        </g>
        <defs>
            <clipPath id="clip0_2461_1034">
                <rect width="18" height="18" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
</template>